var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4277 12.201L13.1501 10.5294C12.697 10.2999 12.1227 10.423 11.8122 10.8226L10.6304 12.3585C9.45648 11.7274 8.56582 11.1392 7.54306 10.1242C6.43279 9.03744 5.86046 8.1292 5.25276 7.0069L6.76112 5.80761C7.16562 5.49798 7.28798 4.9183 7.0449 4.46938L5.35372 1.24076C5.0466 0.670474 4.3246 0.495984 3.7922 0.851381L1.71741 2.25336C1.23329 2.57087 0.96341 3.1415 1.0003 3.70542C1.04373 4.28762 1.12773 5.04079 1.24944 5.55376C1.87092 7.8666 3.32922 10.2716 5.37475 12.3016C7.42027 14.3317 9.82703 15.7584 12.1485 16.3705C12.6733 16.5125 13.4175 16.576 14.0075 16.6122C14.5976 16.6484 15.1562 16.3661 15.4705 15.862L16.8177 13.7516C17.1986 13.2031 17.0049 12.4891 16.4277 12.201Z",
    fill: "#C5C5C5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phoneIcon.bcc3194831080f7f22e8b58d0f6d9252.svg";
export { ForwardRef as ReactComponent };